import { AppRouteRecordRaw } from '../types';
import { ETranslationModule } from '@/i18n/translation';

const Body = () => import('@/components/body.vue');
const FeedbackList = () => import('@/pages/communityandsupport/FeedbackList.vue');
const FeedbackPage = () => import('@/pages/communityandsupport/FeedbackPage.vue');

export const supportAndFeedbackRoutes: AppRouteRecordRaw[] = [
  {
    path: '/support-and-feedback',
    component: Body,
    meta: {
      breadcrumb: 'Support & Feedback',
      i18nModules: [ETranslationModule.feedback],
    },
    children: [
      {
        // Moved to the AI at ryd group; keep old links (notices, bookmarks) working.
        path: 'usage-and-limits',
        redirect: (to) => ({ path: '/ai-at-ryd/usage-and-limits', query: to.query }),
      },
      {
        path: 'requests',
        name: 'My Requests',
        redirect: { name: 'requestsList' },
        meta: {
          breadcrumb: 'My Requests',
        },
        children: [
          {
            path: '',
            name: 'requestsList',
            component: FeedbackList,
            meta: {
              title: 'My Requests | ryd Portal',
              headTitle: 'My Requests',
            },
          },
          {
            path: 'submit',
            name: 'Submit Request',
            component: FeedbackPage,
            meta: {
              title: 'Submit Request | ryd Portal',
              headTitle: 'Submit Request',
              breadcrumb: 'Submit Request',
            },
          },
          {
            path: ':id',
            name: 'View Request',
            component: FeedbackPage,
            meta: {
              title: 'Request Details | ryd Portal',
              headTitle: 'Request Details',
              breadcrumb: 'Request Details',
            },
          },
          {
            path: ':id/edit',
            name: 'Edit Request',
            component: FeedbackPage,
            meta: {
              title: 'Edit Request | ryd Portal',
              headTitle: 'Edit Request',
              breadcrumb: 'Edit Request',
            },
          },
          // Backward compatibility redirects
          {
            path: 'my-requests',
            redirect: { name: 'requestsList' },
          },
          {
            path: 'edit',
            redirect: (to) => ({
              name: 'Edit Request',
              params: { id: to.query.id as string },
            }),
          },
          // -----------------------------------
        ],
      },
    ],
  },
  {
    path: '/candf',
    component: Body,
    meta: {
      breadcrumb: 'Feedback',
      i18nModules: [ETranslationModule.feedback],
    },
    children: [
      {
        path: 'feedback/list',
        name: 'All Feedback',
        component: FeedbackList,
        meta: {
          title: 'All Feedback | ryd Portal',
          breadcrumb: 'All Feedback',
        },
      },
      {
        path: 'feedback/create',
        name: 'Add Feedback',
        component: FeedbackPage,
        meta: {
          title: 'Add Feedback | ryd Portal',
          breadcrumb: 'Add Feedback',
        },
      },
      {
        path: 'feedback/:id',
        name: 'View Feedback',
        component: FeedbackPage,
        meta: {
          title: 'Feedback Detail | ryd Portal',
          breadcrumb: 'Feedback Detail',
        },
      },
      {
        path: 'feedback/:id/edit',
        name: 'Edit Feedback',
        component: FeedbackPage,
        meta: {
          title: 'Edit Feedback | ryd Portal',
          breadcrumb: 'Edit Feedback',
        },
      },
      // Backward compatibility redirect
      {
        path: 'feedback/edit',
        redirect: (to) => ({
          name: 'Edit Feedback',
          params: { id: to.query.id as string },
        }),
      },
      // -----------------------------------
    ],
  },
];
